import { useTranslation } from 'next-i18next'

import PanelElementContainer from '~/panels/components/PanelElementContainer'
import useGetCompletedSessions from '~/panels/hooks/useGetCompletedSessions'

import SessionsLogList from './SessionsLogList'

export default function PanelSessionsLog({
  className,
  isTutor,
}: {
  className?: string
  isTutor?: boolean
}): React.ReactElement {
  const { t } = useTranslation(['generics', 'studentPanel'])
  const completedSessions = useGetCompletedSessions()

  return (
    <PanelElementContainer className={className}>
      <span className="font-semibold">{t('generics:log')}</span>
      {completedSessions && completedSessions.length > 0 ? (
        <SessionsLogList completedSessions={completedSessions} isTutor={isTutor} />
      ) : (
        <span className="block text-xxs text-gray-light-fade">{t('studentPanel:noCompletedSessionsYet')}</span>
      )}
    </PanelElementContainer>
  )
}
